<template>
  <div v-show="showHeader">
    <div id="footerVanta">
      <div class="footer_btns d-flex justify-space-between">
        <btn-up></btn-up>
        <btn-feedback></btn-feedback>
      </div>
      <footer-component></footer-component>
    </div>
  </div>  
</template>
  
<script>
  import * as THREE from 'three'
  import NET from 'vanta/dist/vanta.net.min'
  import BtnUp from '@/components/footer/BtnUp'
  import BtnFeedback from '@/components/footer/BtnFeedback.vue'
  import FooterComponent from '@/components/footer/FooterComponent.vue'
  import { mdiAccount } from '@mdi/js'
  
  export default {
    name: 'MainFooter',
    components: {
      BtnFeedback,
      BtnUp,
      FooterComponent
    },
    data () {
      return{
        mdiAccount: mdiAccount
      }
    },
    computed: {
      showHeader(){
        if (this.$route.name == 'Authorization' || this.$route.name == 'ResetPasswordPage')
          return false
        return true
      }
    },
    mounted() {
        this.vantaEffect = NET({
          el: "#footerVanta",
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.00,
          minWidth: 200.00,
          scale: 1.00,
          scaleMobile: 1.00,
          color: 0x0F3384,
          backgroundColor: 0x01174d,
          THREE
        });
      },
      beforeUnmount() {
        this.vantaEffect.destroy();
    }
  }
</script>
